<div class="square-page">
  <header>
    <div><a mat-button routerLink="/tests"><mat-icon>arrow_back</mat-icon> Tests</a>
      <h1>Square API</h1><p>Test your connection and review Square transfers.</p></div>
    <span class="badge" *ngIf="status">{{status.environment | titlecase}} · {{status.configured ? 'Configured' : 'Token required'}}</span>
  </header>
  <section>
    <h2>Connection</h2>
    <label>Environment
      <select [ngModel]="environment" (ngModelChange)="changeEnvironment($event)" [disabled]="busy">
        <option value="sandbox">Sandbox</option>
        <option value="production">Production</option>
      </select>
    </label>
    <p *ngIf="status && !status.configured">Add your Square access token to the Autopilot server to get started.</p>
    <button mat-raised-button color="primary" (click)="connect()" [disabled]="busy || !status?.configured">Test connection</button>
    <span class="success" *ngIf="connected">Connected · {{locations.length}} locations</span>
    <details><summary>Server setup</summary>
      <p>Set the matching <code>SQUARE.SANDBOX_*</code> or <code>SQUARE.PRODUCTION_*</code> settings in <code>server/configuration.ts</code>. This page starts in sandbox; use the environment selector to switch. The rest of Autopilot defaults to production.</p>
      <p>Use the matching token from the <a href="https://developer.squareup.com/apps" target="_blank" rel="noopener noreferrer">Square Developer Console</a>. Required permissions: PAYOUTS_READ and MERCHANT_PROFILE_READ.</p>
      <p *ngIf="status">API version: {{status.apiVersion}}. Tokens stay on the server.</p>
    </details>
  </section>
  <p class="error" role="alert" *ngIf="error">{{error}}</p>
  <section>
    <h2>Transfers</h2>
    <p>Review Square payouts to your bank account or card.</p>
    <fieldset [disabled]="busy" class="filters">
      <label>Location<select [(ngModel)]="locationId"><option value="">Square default location</option><option *ngFor="let location of locations" [value]="location.id">{{location.name}} ({{location.status}})</option></select></label>
      <label>Start date<input type="date" [(ngModel)]="beginDate"></label>
      <label>End date<input type="date" [(ngModel)]="endDate"></label>
      <label>Page size<select [(ngModel)]="limit"><option [ngValue]="25">25</option><option [ngValue]="50">50</option><option [ngValue]="100">100</option></select></label>
      <button mat-raised-button color="primary" (click)="load()" [disabled]="busy || !status?.configured">Fetch transfers</button>
    </fieldset>
    <p>Dates include the whole day in your local timezone. This test only reads Square data.</p>
    <p *ngIf="busy" role="status">Contacting Square…</p>
    <p *ngIf="loaded && !transfers.length">No transfers found for these filters.</p>
    <div class="table-scroll" *ngIf="transfers.length"><table>
      <thead><tr><th>Created</th><th>Transfer</th><th>Status</th><th>Amount</th><th>Fees</th><th>Arrival date</th><th>Destination</th><th>Bank reference</th></tr></thead>
      <tbody><tr *ngFor="let transfer of transfers"><td>{{transfer.created_at | date:'dd MMM yyyy HH:mm'}}</td><td><code>{{transfer.id}}</code><small>{{transfer.type}}</small></td><td>{{transfer.status}}</td><td>{{money(transfer.amount_money)}}</td><td>{{fees(transfer)}}</td><td>{{transfer.arrival_date || '—'}}</td><td>{{transfer.destination_type || '—'}}</td><td>{{transfer.end_to_end_id || '—'}}</td></tr></tbody>
    </table></div>
    <div class="pagination" *ngIf="loaded"><span>{{transfers.length}} transfers loaded</span><button mat-button (click)="load(true)" [disabled]="busy || !cursor">Load next page</button></div>
  </section>
</div>
